module.exports = __webpack_public_path__ + "images/apple-152.png";